export default __webpack_public_path__ + "static/media/location-ui-whitebg.85fb7491.png";